import React, { useState } from 'react';
import { TextInput } from 'apps/sigma2-ui/src/components/ui/TextInput';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

export interface LeverCredentialsFormProps {
  onSubmit: (apiKey: string) => void;
  isLoading: boolean;
  error: string | null;
}

export const LeverCredentialsForm = ({
  onSubmit,
  isLoading,
  error,
}: LeverCredentialsFormProps) => {
  const [apiKey, setApiKey] = useState('');

  const handleSubmit = () => {
    if (apiKey.trim()) {
      onSubmit(apiKey.trim());
    }
  };

  const isValid = apiKey.trim().length > 0;

  return (
    <Spacing size="md" direction="vertical">
      <S2Typography
        variant="body-6"
        translatedContent="Enter your Lever API key"
      />

      <TextInput
        type="password"
        label="API Key"
        placeholder="Enter your Lever API key"
        value={apiKey}
        onChange={(e) => setApiKey(e.currentTarget.value)}
        required
        disabled={isLoading}
        data-qa="lever-api-key-input"
      />

      {error && (
        <S2Typography
          variant="body-6"
          textColorVariant="red-500"
          translatedContent={error}
        />
      )}

      <Button
        variant="primary"
        size="medium"
        data-qa="lever-submit-button"
        behavior={{
          type: 'onClick',
          onClick: () => {
            handleSubmit();
          },
        }}
        disabled={!isValid || isLoading}
      >
        Connect Lever
      </Button>
    </Spacing>
  );
};
